import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warn",
  "use": "icon-warn-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-warn\">\r\n<circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#E70102\" fill-opacity=\"0.3\" />\r\n<circle cx=\"10\" cy=\"10\" r=\"9.5\" stroke=\"#E70102\" stroke-opacity=\"0.5\" />\r\n<rect x=\"9\" y=\"4\" width=\"2\" height=\"8\" rx=\"1\" fill=\"#E70102\" />\r\n<circle cx=\"10\" cy=\"15\" r=\"1\" fill=\"#E70102\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol